import React from "react";
import { motion } from "framer-motion";
import Header from "../components/Header"; // Import the Header component
import { FaEnvelope } from "react-icons/fa6";
import Footer from "../components/Footer";

const Contact = () => {
    return (
        <div className="min-h-screen flex flex-col bg-black text-rose-300">
            {/* Header Section */}
            <Header />

            {/* Main Content */}
            <div className="flex flex-grow pt-28 pb-12 px-4 md:px-8 justify-center items-center">
                <motion.div
                    initial={{ opacity: 0, y: -50 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    className="glass w-full max-w-lg text-center"
                >
                    {/* Contact Title */}
                    <motion.h2
                        initial={{ opacity: 0, y: -50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                        className="text-3xl md:text-5xl font-extrabold mb-6 tracking-wide leading-tight"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                        Get in <span className="text-white">Touch</span>
                    </motion.h2>

                    {/* Contact Description */}
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="text-base md:text-lg mb-8 leading-relaxed"
                    >
                        Have questions or need assistance? Contact us via email, and we’ll
                        get back to you as soon as possible.
                    </motion.p>

                    {/* Email Button */}
                    <motion.a
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                        href="mailto:vanessaulli.business@gmail.com"
                        className="inline-flex items-center justify-center space-x-3 text-rose-300 bg-black border-rose-300 hover:bg-rose-300 hover:text-black py-3 px-6 rounded-lg text-base md:text-lg font-bold shadow-md transition duration-300"
                    >
                        <FaEnvelope size={24} />
                        <span>Send Email</span>
                    </motion.a>
                </motion.div>
            </div>

            {/* Footer Section */}
            <Footer />
        </div>
    );
};

export default Contact;
